// extracted by mini-css-extract-plugin
export default {"container":"SearchBar_container__+YO12","search_bar":"SearchBar_search_bar__rmEPU","search_text":"SearchBar_search_text__bUteP","searchIcon":"SearchBar_searchIcon__X5n58"};